import { PropsWithChildren } from 'react';
import { NotAuthorizedPage } from '../NotAuthorized';
import { useMyOrgUnitAssortments } from '@retail/app/stores/selected-context';

export const OrgUnitAccessChecker: React.FC<PropsWithChildren> = ({ children }) => {
  const { allAssortments } = useMyOrgUnitAssortments();

  if (!allAssortments.length) {
    return <NotAuthorizedPage reason="noOrgUnits" />;
  }

  return children;
};
